
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'DialogOptions',
    props:{
        group: {
            type: String,
            required: true,
        },
        scheduleInformation: {
            type: Object,
            required: true,
        },
    },
    setup() {
        return {};
    },
    data(){
        return{
            daysWeek: [
            { id: 0, name: "Domingo", code: "SUNDAY"},
            { id: 1, name: "Segunda", code: "MONDAY" },
            { id: 2, name: "Terça", code: "TUESDAY" },
            { id: 3, name: "Quarta", code: "WEDNESDAY" },
            { id: 4, name: "Quinta", code: "THURSDAY" },
            { id: 5, name: "Sexta", code: "FRIDAY" },
            { id: 6, name: "Sábado", code: "SATURDAY" },
            ],
        }
    }
});
